import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { ShieldCheck } from "lucide-react";
import { computeDataCompleteness } from "@/lib/dataCompleteness";

const LEVEL_COLOR = {
  low: "#FF3B30",
  medium: "#FFCC00",
  high: "#22C55E",
};

export const ReliabilityBadge = ({ input, dark = false }) => {
  const { t } = useLang();
  const { score, level } = computeDataCompleteness(input);
  const color = LEVEL_COLOR[level];

  return (
    <div data-testid="reliability-badge" className={dark ? "text-white" : "text-black"}>
      <div className="flex items-center justify-between gap-3">
        <span className={`overline ${dark ? "text-[#737373]" : "text-[#737373]"} inline-flex items-center gap-1.5`}>
          <ShieldCheck size={13} style={{ color }} /> {t.results.data_reliability}
        </span>
        <span data-testid="reliability-level" className="font-display font-black tracking-tight text-xl" style={{ color }}>
          {t.results.reliability[level]} · {score}%
        </span>
      </div>
      <div className={`mt-2 h-2 w-full ${dark ? "bg-white/15" : "bg-black/10"}`}>
        <div
          data-testid="reliability-bar"
          className="h-full transition-all duration-500"
          style={{ width: `${score}%`, backgroundColor: color }}
        />
      </div>
      <p className={`text-[11px] mt-2 ${dark ? "text-[#A0A0A0]" : "text-[#737373]"}`}>{t.results.data_reliability_hint}</p>
    </div>
  );
};

export default ReliabilityBadge;
